/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { get, map, pickBy, identity, isEmpty, find, filter } from "lodash";
import {
  IconButton,
  Stack,
  Menu,
  Button,
  MenuItem,
  Link as LinkMui,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReplayIcon from '@mui/icons-material/Replay';
import AddIcon from '@mui/icons-material/Add';

import Table from "../../../components/form/Table";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Question from "../../../components/form/Question";
import PaymentsModal from "./PaymentsModal"

import PaymentEditModal from "./PaymentEditModal";

import { getRoutePaymentAll } from "../../../store/transactions/thunk/route/getPaymentAll";
import { putRoute } from "../../../store/transactions/thunk/route/put";
import { getPayment } from "../../../store/transactions/thunk/payment/getAll";
import { getPaymentClient } from "../../../store/transactions/thunk/paymentClients/getAll";
import { getRouteId } from "../../../store/transactions/thunk/route/getId";
import { deleteRoutePayment } from "../../../store/transactions/thunk/route/deletePayment";
import { putRoutePayment } from "../../../store/transactions/thunk/route/putPayment";
import { useCanView } from "../../../config/hook/UserPermissions";

const Payment = ({ setBtns, isEdit }) => {
  const [__] = useTranslation("route");
  const [__c] = useTranslation("payment");
  const { id } = useParams();
  const dispatch = useDispatch();
  const canView = useCanView();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
  const [openModal, setOpenModal] = useState(false);
  const [paymentsSelected, setPaymentsSelected] = useState([])
  const [openQuestion, setOpenQuestion] = useState(null);
  const [toSelected, setToSelected] = useState({});
  const [toEdit, setToEdit] = useState({});
  const [valuePayment, setValuePayment] = useState();
  const [openModalEdit, setOpenModalEdit] = useState(false);

  const route = useSelector(state => state.transactions.route.paymentAll);
  const currentRoute = useSelector(state => state.transactions.route.detail);
  const actualPayments = useSelector(state => state.transactions.route.paymentAll);
  const put = useSelector(state => state.transactions.route.putPayment);
  const delet = useSelector(state => state.transactions.route.deletePayment);
  const post = useSelector(state => state.transactions.route.postPayment);
  const paymentClient = useSelector(state => state.transactions.paymentClient); 
  const putPayment = useSelector(state => state.transactions.route.putPayment);

  const getData = () => {
    dispatch(getRouteId( id ));
  }
  const getDataPayment = () => {
    dispatch(getPaymentClient({ CustomerId: get(currentRoute, "data.customerId"), Export: true }));
  }

  const reload = () =>  getData({ page: 1 })
  
  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1 });
  }, [dispatch])

  useEffect(() => {
    if (get(currentRoute, "isSuccess") && get(currentRoute, "data.customerId")) {
      getDataPayment();
    }
  }, [get(currentRoute, "isSuccess"), get(currentRoute, "data.customerId")])

  useEffect(() => {
    setPaymentsSelected(map(get(route, "data", []), ({ idTypePayment }) => idTypePayment))
  }, [get(route, "data.length")]);


  useEffect(() => {
    setBtns(
      <Stack className='mr-4' direction="row" spacing={1} justifyContent="flex-end">
        {isEdit ? <Button className='w-[100px] min-w-[100px]' startIcon={<AddIcon/>} variant="contained" color="secondary" onClick={() => {
          if (canView("TRANSACCIONES/RUTAS/COBROS", "add")) {
            setOpenModal(true)
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para agregar nuevos cobros a la ruta.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }}>{__(`toolbar.add`)}</Button> : <div className='flex-1' />}
        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
      </Stack>
    )
  }, [isEdit]);

  const handleOpenMenu = (row) => (event) => {
    setToSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setToSelected({})
    setAnchorEl(null);
  };

  const onCancel = () => {
    setValuePayment(undefined)
    setToEdit({})
    setToSelected({})
    setOpenQuestion(false)
  }

  const onDelete = () => {
    dispatch(deleteRoutePayment({ id: Number(get(toSelected, "id")), idRoute: Number(id) }))
    setSelected({})
    setOpenModal(false)
  }

  const handleDelete = (row) => () => {
    setAnchorEl(null);
    setOpenQuestion(true)
    setToSelected(row)
  }

  const handleUpdate = (row) => () => {
    setToEdit(row);
    setAnchorEl(null);
    setOpenModalEdit(true);
  };

  const HandelUpdatePayment = (payment) => {
    dispatch(putRoutePayment(payment));
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
    })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { onCancel(); setOpenModal(false); setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    if (get(post, "isSuccess", false)) { setOpenModal(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "put") }
    if (get(putPayment, "isSuccess", false)) { onCancel(); setOpenModal(false); setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(putPayment, "isReject", false)) { setError(get(putPayment, "error", {}), "put") }
  }, [put, post, delet, putPayment]);

  const headTable = [
    {
      key: "cod_Invoice",
      label: __(`table.colsPayment.idPayment`),
      align: "center"
    },
    {
      key: "quantity",
      label: __(`table.colsPayment.quantity`),
      align: "center"
    },
    {
      key: "descriptionCodeInvoice",
      label: __(`table.colsPayment.description`),
      align: "center"
    },
    {
      key: "price",
      label: __(`table.colsPayment.price`),
      align: "center"
    },
    {
      key: "options",
      label: __(`table.colsPayment.options`),
      align: "center",
      sx: { position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]
  //console.log("Routa del lado de cobros: ", currentRoute)
  const dataTable = map(get(currentRoute, "data.routeBillings", []), (row, i) => ({
    ...row,
    // delete: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)} ><DeleteIcon fontSize="inherit" /></IconButton>
    price: `$ ${get(row, "price", 0)?.toFixed(2)}`,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  return (
    <div>
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(currentRoute, "isLoading", false)}
        empty="payments"
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <MenuItem onClick={handleUpdate(toSelected)}>{__(`table.menu.edit`)}</MenuItem>
        <MenuItem onClick={ () => {
          if (canView("TRANSACCIONES/RUTAS/COBROS", "delete")) { 
            handleDelete(toSelected)();
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para eliminar cobros de la ruta.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }}>{__(`table.menu.delete`)}</MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <PaymentsModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
        showNoti={showNoti}
        setShowNoti={setShowNoti}
        alert={alert}
        setAlert={setAlert}
        setError={setError}
        reload={reload}
        selected={paymentsSelected}
        setSelected={setPaymentsSelected}
      />
      <PaymentEditModal
        __={__}
        open={openModalEdit}
        close={() => setOpenModalEdit(false)}
        selected={toEdit}
        update={HandelUpdatePayment}
      />
      <Question
        title={__("alert.deletePayment")}
        detail={""}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </div >
  )
}

export default Payment;
